/**
 * What the gate must do for an enforcement mode.
 *
 * - `none`: the dialog is not mounted at all.
 * - `dismissible`: the dialog is mounted and it has a way out — the user can close it and keep using
 *   the application.
 * - `blocking`: the dialog is mounted and there is no way out but finishing the flow.
 */
export type GateEnforcement = 'none' | 'dismissible' | 'blocking';

/**
 * What the gate must do for the enforcement mode the backend sent.
 *
 * A missing value, or one from a contract this build does not know, fails open to `none`: the wrong
 * failure here locks the whole user base out over a string the front end did not recognise. The
 * comparison is exact for the same reason — a mode it cannot read is a mode it does not enforce.
 */
export const gateEnforcementFor = (mode: string | undefined): GateEnforcement => {
  if (mode === 'hard') return 'blocking';
  if (mode === 'soft') return 'dismissible';

  return 'none';
};
